import {Nut_Settings_User} from 'nutshell-core/settings-constants';
import type {User} from 'nutshell-core/users/users-types';

import type {Lead} from 'nutshell-graphql-types';

import {useActionBarFormTabSelection} from '../../../core-entity/hooks/use-action-bar-form-tab-selection';
import {TAB_CALL} from '../../../core-entity/redux/consts';
import {
    getTabOptions,
    useHandleCallClick,
    useOpenEmailModal,
    useOpenTextModal,
} from '../../../core-entity/util/action-bar-helpers';
import {ActionBar as EntityActionBar} from '../../../core-entity/workspace/action-bar';

type Props = {
    lead: Lead;
    user: User | null | undefined;
    getRef: (ref: HTMLDivElement | null) => void;
    hasScrolledPastCheckpoint: boolean;
};

export function ActionBar(props: Props) {
    const {actionBarTab, handleSelectFormTab} = useActionBarFormTabSelection(
        Nut_Settings_User.SETTING_LEAD_PAGE_ACTION_BAR_TAB
    );

    const openEmailModal = useOpenEmailModal(props.lead);
    const {openTextModal, featureGate} = useOpenTextModal(props.lead, props.user);
    const {handleCallClick, popoverComponent} = useHandleCallClick(TAB_CALL, props.lead.id, {
        noPhoneNumbersQuestion: 'No phone numbers associated with this lead',
        trackPhoneIntegrationOnboardFromLeadPage: true,
    });

    return (
        <>
            <EntityActionBar
                options={getTabOptions(openEmailModal, openTextModal, handleCallClick)}
                selectedTab={actionBarTab}
                onSelectTab={handleSelectFormTab}
                getRef={props.getRef}
                entityDisplayName={props.lead.name}
                timelineEventFormProps={{
                    entityId: props.lead.id,
                    entityName: 'Leads',
                    canOpen: !props.hasScrolledPastCheckpoint,
                }}
            />
            {featureGate}
            {popoverComponent}
        </>
    );
}
